export default __webpack_public_path__ + "static/media/Verified.069cb7a1.svg";